import { render, staticRenderFns } from "./HomeLiveCard.vue?vue&type=template&id=aac34bd8&scoped=true&"
import script from "./HomeLiveCard.vue?vue&type=script&lang=js&"
export * from "./HomeLiveCard.vue?vue&type=script&lang=js&"
import style0 from "./HomeLiveCard.vue?vue&type=style&index=0&id=aac34bd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aac34bd8",
  null
  
)

export default component.exports